import { Button, Popconfirm, Tooltip } from "antd";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import AppUsersIcon from "../../../assets/icons/AppUsersIcon";
import ButtonEditIcon from "../../../assets/icons/ButtonEditIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import TotalClientsIcon from "../../../assets/icons/TotalClientsIcon";
import defaultImage from "../../../assets/images/default.png";
import Loader from "../../../components/ui/Loader";
import {
  useDeleteProductMutation,
  useGetAllProductQuery,
  useUserCompanyCountQuery,
} from "../../../features/portal/Products/productsApi";
import useError from "../../../hooks/useError";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { toast } from "../../../lib/toast";

export default function Products() {
  const navigate = useNavigate();

  const {
    isLoading: isAllProductLoading,
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({
    params: {
      status: undefined,
      limit: 100000,
    },
  });

  const {
    isLoading: userCompanyCountIsLoading,
    isError: userCompanyCountIsError,
    error: userCompanyCountError,
    data: userCompanyCountData,
  } = useUserCompanyCountQuery({});

  const [deleteProduct, { isLoading: deleteProductLoading, isError, error }] =
    useDeleteProductMutation();

  useError(isAllProductError, allProductError, "Get all product fail");
  useError(
    userCompanyCountIsError,
    userCompanyCountError,
    "Get company count fail"
  );
  useError(isError, error, "Delete product fail");

  const allProduct = getAllProduct?.data?.data;

  const handleDeleteProduct = async (id: number) => {
    const payload = {
      id,
    };
    const result = await deleteProduct(payload);
    if ("data" in result) {
      toast("success", "Product deleted successfully");
    }
  };

  return (
    <SidebarLayout title="Products">
      <div className="mb-4 flex justify-end">
        <Button
          type="primary"
          className="middle-button"
          icon={<AddIcon />}
          onClick={() => navigate(`/admin/products/product-list/add-product`)}
        >
          Add New Product
        </Button>
      </div>

      {isAllProductLoading || userCompanyCountIsLoading ? (
        <Loader />
      ) : (
        <div className="space-y-6">
          {allProduct?.map((item) => {
            const value = userCompanyCountData?.data[item?.id];
            return (
              <div
                className="bg-white rounded border border-[#e9eff6] grid grid-cols-[40%_60%]"
                key={item?.id}
              >
                {/* <div className="h-[220px]">
                  <img
                    src={item?.logo || defaultImage}
                    alt="product_image"
                    className="max-w-full h-full object-cover rounded-l-lg"
                  />
                </div> */}

                <div className="w-96 h-[220px] flex items-center justify-center bg-gray-100 rounded-l-lg">
                  <img
                    src={item?.logo || defaultImage}
                    alt="product_image"
                    className="max-w-full max-h-full object-contain p-2"
                  />
                </div>

                <div className="h-[220px]">
                  <div className="!w-full   p-6 ">
                    {/* 1 */}
                    <div className="">
                      <div className="flex items-center justify-between w-full mb-3">
                        <div>
                          <Tooltip title={item?.name}>
                            <h5 className="text-display-body text-[22px] font-semibold leading-[35px] w-[310px] truncate overflow-hidden whitespace-nowrap">
                              {item?.name}
                            </h5>
                          </Tooltip>
                        </div>

                        <div className="flex justify-between items-center gap-3">
                          <div className="justify-start text-blue-500 text-sm font-medium italic">
                            Product Type
                          </div>
                          {item?.status === "draft" ? (
                            <div className="px-2 py-1 bg-yellow-50 rounded-md inline-flex justify-center items-center gap-2.5">
                              <div className="justify-start text-yellow-600 text-sm font-semibold">
                                Draft
                              </div>
                            </div>
                          ) : item?.status === null ? (
                            item?.is_active === true ? (
                              <div className="px-2 py-1 bg-green-500/10 rounded-md inline-flex justify-center items-center gap-2.5">
                                <div className="justify-start text-green-600 text-sm font-semibold">
                                  Active
                                </div>
                              </div>
                            ) : (
                              <div className="px-2 py-1 bg-red-50 rounded-md inline-flex justify-center items-center gap-2.5">
                                <div className="justify-start text-red-500 text-sm font-semibold">
                                  Inactive
                                </div>
                              </div>
                            )
                          ) : null}

                          <div
                            className="cursor-pointer bg-[#FE7235] rounded px-2 py-1"
                            onClick={() =>
                              navigate(
                                `/admin/products/product-list/edit-product/${item?.id}`
                              )
                            }
                          >
                            <ButtonEditIcon />
                          </div>

                          <Popconfirm
                            title="Delete product"
                            description="Are you sure you want to delete this product?"
                            onConfirm={() => handleDeleteProduct(Number(item?.id))}
                            okText="Delete"
                            cancelText="Cancel"
                            okButtonProps={{
                              danger: true,
                              loading: deleteProductLoading,
                            }}
                          >
                            <div className="cursor-pointer bg-[#FF3838] rounded px-2 py-1">
                              <DeleteIcon color="#fff" />
                            </div>
                          </Popconfirm>

                          <div className="!min-w-8 !max-w-10 h-8 flex items-center justify-center border border-zinc-400 rounded-full text-sm font-semibold">
                            {item?.sort_order ? item?.sort_order : "0"}
                          </div>
                        </div>
                      </div>

                      <Tooltip title={item?.description}>
                        <div className="text-[#5e718d] text-sm font-normal leading-normal h-[65px] line-clamp-3 overflow-hidden mb-1">
                          {item?.description}
                        </div>
                      </Tooltip>
                    </div>
                    <div className="flex justify-start items-center gap-4">
                      {/* <CountInfo
                    icon={<ActiveFeaturesIcon />}
                    count="24"
                    text="Active features"
                    color="bg-[#fff4f4]"
                  />
                  <div className="w-0 h-11 origin-top-bottom rotate-180 outline outline-1 outline-offset-[-0.50px] outline-zinc-200"></div>
                   */}

                      <div className="flex justify-start items-center gap-4">
                        <CountInfo
                          icon={<TotalClientsIcon />}
                          count={value?.totalUser ?? 0}
                          text="total clients"
                          color="bg-[#FFF9DF]"
                        />
                        <div className="w-0 h-11 origin-top-bottom rotate-180 outline outline-1 outline-offset-[-0.50px] outline-zinc-200"></div>
                        <CountInfo
                          icon={<AppUsersIcon />}
                          count={value?.company ?? 0}
                          text="app users"
                          color="bg-[#F2F5FF]"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </SidebarLayout>
  );
}

type props = {
  icon: ReactNode;
  count: number;
  text: string;
  color?: string;
};
function CountInfo({ icon, count, text, color }: props) {
  return (
    <>
      <div className="justify-start items-center">
        <div className="justify-start items-center gap-[11px] flex">
          <div
            className={`w-9 h-9 flex justify-center items-center rounded-full  ${color}`}
          >
            {icon}
          </div>

          <div className="flex-col justify-start items-start inline-flex">
            <div className="self-stretch text-display-body text-lg font-bold ">
              {count}
            </div>
            <div className="text-[#8797ae] text-xs font-medium  uppercase leading-normal">
              {text}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
